var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"easyscreen-form-section"},[(_vm.title)?_c('h3',{staticClass:"easyscreen-form-section--title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"easyscreen-form-section--content",style:(_vm.contentStyle)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }